<template>
  <div class="pa-0 ma-0 mainContainer">
    <v-row :class="justifyClass">
      <v-col class="mainColumn pa-0">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        windowWidth: window.innerWidth
      };
    },
    computed: {
      justifyClass() {
        return this.windowWidth < 1440 ? 'justify-start' : 'justify-center';
      }
    }
  };
</script>

<style>
  .mainContainer {
    min-width: 1440px;
  }
  .mainColumn {
    max-width: 1440px;
    width: 100%;
    min-width: 1440px;
    height: 100%;
  }
  .gradient-div {
    background: linear-gradient(
      to top right,
      #c2c2c2,
      rgba(143, 148, 251, 0.2)
    );
  }
</style>
